import { Injectable } from '@angular/core';
import { HttpClient,HttpHeaders } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { DataService } from '../../../services/data.service';
import { BusinessSubcriptionRequest } from '../../../POS/models/business-subcription-request';
import { BusinessHours } from '../../../POS/models/business-hours';
import { CommonFunctionService, UserPOSData} from '../../../services/Common/common-function.service';
import { map } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class BusinesshoursService {
  userId: any;
  token;
  headers: any;
  constructor(private service: DataService, private http: HttpClient,private common:CommonFunctionService) {
    let loggedUsername =this.common.getUserName()
    this.token =environment.GetAuthenticationToken + ":" +this.common.GetAuthToken()+ ":" + "IT"+ ":"+environment.GetAuthencticationKey+":"+this.common.getSid();
    this.headers = new HttpHeaders().
    set('Authorization', 'basic ' + btoa(this.token));
   }
  
  AddBusinessHours(data)
  {
    this.GetGeaderdetails();
    return this.http.post(environment.AddBusinessHoursUrl, data,{headers:this.headers});
  }
  UpdateBusinessHours(data) {
    this.GetGeaderdetails();
    // return this.service.put(
    //   environment.UpdateBusinessHoursUrl + "?PosSubscriptionId=" + data.PosSubscriptionId+"&id="+data.Id,data );
    return this.http.post(
      environment.UpdateBusinessHoursUrl ,data ,{headers:this.headers});
  }
  GetBusinessHoursDetail(data) {
    this.GetGeaderdetails();
    return this.http.get<BusinessHours>(environment.GetBusinessHoursDetailUrl + "?PosSubscriptionId=" + data.PosSubscriptionId+"&id="+data.id,{headers:this.headers})
    .pipe(map(response => response))    ;
  }
  Getbusinesshoursweekdaysdays(data) {
    this.GetGeaderdetails();
    return this.http.get<BusinessHours>(environment.Getbusinesshoursweekdaysdays + "?PosSubscriptionId=" + data.PosSubscriptionId+"&WeekDay="+data.WeekDay,{headers:this.headers})
    .pipe(map(response => response))    ;
  }
  GetBusinessHoursListUrl(data)
  {
    this.GetGeaderdetails();
    return this.http.get<BusinessHours>(environment.GetBusinessHoursListUrl + "?PosSubscriptionId=" + data,{headers:this.headers})
    .pipe(map(response => response))    ;
  }
  GetBusinesshoursFilterList(PosSubscriptionId,Fromdate1,todate1,HoursType,WeekDay)
  {
    this.GetGeaderdetails();
    return this.http.get<BusinessHours>(environment.GetBusinesshoursFilterList+"?PosSubscriptionId="+PosSubscriptionId+"&fromdate="+Fromdate1+"&todate="+todate1+"&Hourstype="+ 
     HoursType+"&Weekday="+WeekDay,{headers:this.headers})
     .pipe(map(response => response))    ;
  }
  GetGeaderdetails()
  {
    let loggedUsername =this.common.getUserName()
    this.token =environment.GetAuthenticationToken + ":" +this.common.GetAuthToken()+ ":" + "IT"+ ":"+environment.GetAuthencticationKey+":"+this.common.getSid();
    this.headers = new HttpHeaders().
    set('Authorization', 'basic ' + btoa(this.token));

  }
}
